import React from 'react';

export const DataCard = ({ card, onFuente }) => (
  <section className="data-card" data-testid="data-card">
    <header className="data-card-k">{card.k}</header>
    <dl>
      {card.rows.map(([label, val], i) => (
        <div className="data-card-row" key={i}>
          <dt>{label}</dt>
          <dd>
            <button
              type="button"
              className="data-card-val"
              title="Ver origen de esta cifra"
              onClick={() => onFuente(card.src)}
              data-testid={`card-valor-${i}`}
              dangerouslySetInnerHTML={{ __html: String(val).replace(/\n/g, '<br/>') }}
            />
          </dd>
        </div>
      ))}
    </dl>
    <footer>
      <button type="button" className="fuente-link" onClick={() => onFuente(card.src)} data-testid="card-fuente">
        ¿De dónde sale esto? Ver la fuente
      </button>
    </footer>
  </section>
);
